module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"backToHome":"Home Page"}}')
  delete Component.options._Ctor
}
